import { ShopOutlined }        from '@ant-design/icons';
import { WarningOutlined }     from '@ant-design/icons';
import { CheckCircleOutlined } from '@ant-design/icons';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Button }              from 'antd';
import Row                     from 'components/App/Row';
import { Col }                 from 'antd';
import { observer }            from 'mobx-react';
import { useNavigate }         from 'react-router-dom';
import BorderedCol             from 'components/App/BorderedCol';
import currentSession          from 'utils/currentSession';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import CardBox                 from 'components/App/CardBox';
import { showDashboardStore }  from 'stores/index';

const ShowDashboardPlansInformationsBox = observer(({
  id,
  totalStandCollectionWarning,
  totalStandCollectionWarningClosed,
}: {
  id: id;
  totalStandCollectionWarning: number;
  totalStandCollectionWarningClosed: number;
}) => {
  const navigate = useNavigate();

  const dataLoading =
    !showDashboardStore.standCollection.isLoaded ||
    showDashboardStore.standCollection.isLoading ||
    !showDashboardStore.standCollectionUnSeen.isLoaded ||
    showDashboardStore.standCollectionUnSeen.isLoading ||
    !showDashboardStore.standCollectionValidated.isLoaded ||
    showDashboardStore.standCollectionValidated.isLoading ||
    !showDashboardStore.standCollectionWaiting.isLoaded ||
    showDashboardStore.standCollectionWaiting.isLoading ||
    !showDashboardStore.standCollectionPendingVerification.isLoaded ||
    showDashboardStore.standCollectionPendingVerification.isLoading ||
    !showDashboardStore.standCollectionPendingConfirmation.isLoaded ||
    showDashboardStore.standCollectionPendingConfirmation.isLoading;

  return (
    <CardBox
      content={
        <>
          <Row>
            <BorderedCol lg={12} md={12} span={24} xl={8}>
              <Row>
                <Col lg={4} md={4} sm={4} style={styleColIcon} xl={6} xs={4}>
                  <ShopOutlined style={{ ...styleIcon, color: '#3498db' }} />
                </Col>
                <Col lg={20} md={20} sm={20} xl={18} xs={20}>
                  <b>
                    <FormattedMessageWrapper id="Stands :" />
                  </b>
                  <br />
                  <FormattedMessageWrapper id="Total :" />
                  {` `}
                  {showDashboardStore.standCollection.total}
                </Col>
              </Row>
            </BorderedCol>
            <BorderedCol lg={12} md={12} span={24} xl={8}>
              <Row>
                <Col lg={4} md={4} sm={4} style={styleColIcon} xl={6} xs={4}>
                  <WarningOutlined style={{ ...styleIcon, color: '#f1c40f' }} />
                </Col>
                {(currentSession.isAdminOrSupport || currentSession.isOrganizer) && (
                  <Col lg={20} md={20} sm={20} xl={18} xs={20}>
                    <b>
                      <FormattedMessageWrapper id="Nouveaux messages :" />
                    </b>
                    <br />
                    Total: {showDashboardStore.standCollectionUnSeen.total}
                  </Col>
                )}
              </Row>
            </BorderedCol>
            <BorderedCol lg={12} md={12} span={24} xl={8}>
              <Row>
                <Col lg={4} md={4} sm={4} style={styleColIcon} xl={6} xs={4}>
                  <WarningOutlined style={{ ...styleIcon, color: '#f1c40f' }} />
                </Col>
                {(currentSession.isAdminOrSupport || currentSession.isOrganizer) && (
                  <Col lg={20} md={20} sm={20} xl={18} xs={20}>
                    <b>
                      <FormattedMessageWrapper id="Non-traité :" />
                    </b>
                    <br />
                    Total: {showDashboardStore.standCollectionUnSeen.total}
                  </Col>
                )}
              </Row>
            </BorderedCol>
          </Row>
          <Row>
            <BorderedCol lg={24} md={24} sm={12} span={24} xl={12}>
              <Row>
                <Col lg={4} md={4} sm={4} style={styleColIcon} xl={6} xs={4}>
                  <WarningOutlined style={{ ...styleIcon, color: '#f1c40f' }} />
                </Col>
                <Col lg={20} md={20} sm={20} xl={18} xs={20}>
                  <b>
                    <FormattedMessageWrapper id="Constats en cours :" />
                  </b>
                  <br />
                  <FormattedMessageWrapper id="Total :" />
                  {` `}
                  {totalStandCollectionWarning}
                </Col>
              </Row>
            </BorderedCol>
            <BorderedCol lg={24} md={24} sm={12} span={24} xl={12}>
              <Row>
                <Col lg={4} md={4} sm={4} style={styleColIcon} xl={6} xs={4}>
                  <WarningOutlined style={{ ...styleIcon, color: '#f1c40f' }} />
                </Col>
                <Col lg={20} md={20} sm={20} xl={18} xs={20}>
                  <b>
                    <FormattedMessageWrapper id="Constats clôturés :" />
                  </b>
                  <br />
                  <FormattedMessageWrapper id="Total :" />
                  {` `}
                  {totalStandCollectionWarningClosed}
                </Col>
              </Row>
            </BorderedCol>
          </Row>
          <Row>
            <BorderedCol lg={24} md={24} sm={12} span={24} xl={12}>
              <Row>
                <Col lg={4} md={4} sm={4} style={styleColIcon} xl={6} xs={4}>
                  <CheckCircleOutlined style={{ ...styleIcon, color: '#2ecc71' }} />
                </Col>
                <Col lg={20} md={20} sm={20} xl={18} xs={20}>
                  <b>
                    <FormattedMessageWrapper id="Plans validés :" />
                  </b>
                  <br />
                  <FormattedMessageWrapper id="Total :" />
                  {` `}
                  {showDashboardStore.standCollectionValidated.total}
                </Col>
              </Row>
            </BorderedCol>
            <BorderedCol lg={24} md={24} sm={12} span={24} xl={12}>
              <Row>
                <Col lg={4} md={4} sm={4} style={styleColIcon} xl={6} xs={4}>
                  <CloseCircleOutlined style={{ ...styleIcon, color: '#e74c3c' }} />
                </Col>
                <Col lg={20} md={20} sm={20} xl={18} xs={20}>
                  <b>
                    <FormattedMessageWrapper id="Plans non validés :" />
                  </b>
                  <br />
                  <FormattedMessageWrapper id="Total :" />
                  {` `}
                  {showDashboardStore.standCollectionWaiting.total +
                    showDashboardStore.standCollectionPendingVerification.total +
                    showDashboardStore.standCollectionPendingConfirmation.total}
                </Col>
              </Row>
            </BorderedCol>
          </Row>
          <Row>
            <BorderedCol lg={24} md={24} span={24} xl={8}>
              <Row>
                <Col lg={4} md={4} sm={4} style={styleColIcon} xl={6} xs={4} />
                <Col lg={20} md={20} sm={20} xl={18} xs={20}>
                  <b>
                    <FormattedMessageWrapper id="En attente réception :" />
                  </b>
                  <br />
                  <FormattedMessageWrapper id="Total :" />
                  {` `}
                  {showDashboardStore.standCollectionWaiting.total}
                </Col>
              </Row>
            </BorderedCol>
            <BorderedCol lg={12} md={12} span={24} xl={8}>
              <Row>
                <Col lg={4} md={4} sm={4} style={styleColIcon} xl={6} xs={4} />
                <Col lg={20} md={20} sm={20} xl={18} xs={20}>
                  <b>
                    <FormattedMessageWrapper id="A vérifier :" />
                  </b>
                  <br />
                  <FormattedMessageWrapper id="Total :" />
                  {` `}
                  {showDashboardStore.standCollectionPendingVerification.total}
                </Col>
              </Row>
            </BorderedCol>
            <BorderedCol lg={12} md={12} span={24} xl={8}>
              <Row>
                <Col lg={4} md={4} sm={4} style={styleColIcon} xl={6} xs={4} />
                <Col lg={20} md={20} sm={20} xl={18} xs={20}>
                  <b>
                    <FormattedMessageWrapper id="A confirmer :" />
                  </b>
                  <br />
                  <FormattedMessageWrapper id="Total :" />
                  {` `}
                  {showDashboardStore.standCollectionPendingConfirmation.total}
                </Col>
              </Row>
            </BorderedCol>
          </Row>

          <Row>
            <Col span={24}>
              <Button
                block
                htmlType="button"
                onClick={() => navigate(`/salons/${id}/stands`)}
                type="primary"
              >
                <FormattedMessageWrapper id="Voir les stands" />
              </Button>
            </Col>
          </Row>
        </>
      }
      loading={dataLoading}
      title={<FormattedMessageWrapper id="Informations Plans" />}
    />
  );
});

const styleColIcon: {
  textAlign: 'center',
} = {
  textAlign: 'center',
};

const styleIcon = {
  fontSize: '24px',
  marginTop: 4,
};

export default ShowDashboardPlansInformationsBox;
